type SnowplowPageViewTracker = {
  getPageViewId?: () => string | null | undefined
}

type SnowplowTrackerCallbackContext = {
  sp?: SnowplowPageViewTracker
}

type SnowplowUserStateContext = {
  schema: 'iglu:com.eezy/user_state/jsonschema/1-0-5'
  data: {
    pageviewGuid: string | null
  }
}

export const getSnowplowPageviewGuid = (): string | null => {
  let pageviewGuid: string | null = null

  window.snowplow?.(function (this: SnowplowTrackerCallbackContext) {
    pageviewGuid = this.sp?.getPageViewId?.() || null
  })

  return pageviewGuid
}

export const buildSnowplowUserStateContext =
  (): (() => SnowplowUserStateContext) => () => ({
    schema: 'iglu:com.eezy/user_state/jsonschema/1-0-5',
    data: {
      pageviewGuid: getSnowplowPageviewGuid(),
    },
  })

export const trackSnowplowPageView = (): boolean => {
  if (!window.snowplow) {
    return false
  }

  window.snowplow('trackPageView')
  return true
}
